import { render } from "./SalesReturnCreation.vue?vue&type=template&id=d95618a0"
import script from "./SalesReturnCreation.vue?vue&type=script&lang=js"
export * from "./SalesReturnCreation.vue?vue&type=script&lang=js"

import "./SalesReturnCreation.vue?vue&type=style&index=0&id=d95618a0&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__